// @flow
import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import { useI18n, withI18n } from "@quantum/i18n";

import { compose, isNil } from "ramda";

import SelectInput from "../../../comum/SelectInput";

import {
  type ActionCreator,
  getEscalaMoedas,
  selecionarEscalaMoeda,
  getEscalaMoedaSelecionada,
} from "../../../../state";

import { type Id, type EscalaMoeda } from "../../../../model";

type Prop = {
  listaItens: Array<EscalaMoeda>,
  escalaMoedaSelecionada: Id,
  selecionarEscalaMoeda: ActionCreator,
  valorPadrao: Id,
  nomeMedida: string,
};

function SelecaoEscalaMoeda({
  listaItens,
  escalaMoedaSelecionada,
  selecionarEscalaMoeda,
  valorPadrao,
  nomeMedida,
}: Prop) {
  const { translate } = useI18n();

  const onChange = useCallback(
    id => {
      selecionarEscalaMoeda(id);
    },
    [selecionarEscalaMoeda]
  );

  useEffect(() => {
    const escala = isNil(escalaMoedaSelecionada)
      ? valorPadrao
      : escalaMoedaSelecionada;
    selecionarEscalaMoeda(escala);
  }, [nomeMedida, escalaMoedaSelecionada, valorPadrao, selecionarEscalaMoeda]);

  return (
    <>
      <div className="ConfiguracaoMedida">
        <label className="ConfiguracaoMedida__label-nowrap ">
          {translate("configuracaoRelatorio.escala.labelSelect")}
        </label>
        <SelectInput
          className="ConfiguracaoMedida__input-select"
          value={
            isNil(escalaMoedaSelecionada) ? valorPadrao : escalaMoedaSelecionada
          }
          options={listaItens}
          searchable={false}
          onChange={onChange}
          onBlur={onChange}
          campoDescricao="traducao"
          campoId="id"
        />
      </div>
    </>
  );
}

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaItens: getEscalaMoedas(state).map(escalaMoeda => ({
        ...escalaMoeda,
        traducao: ownProps.translate(escalaMoeda.chaveTraducao),
      })),
      escalaMoedaSelecionada: getEscalaMoedaSelecionada(state),
    }),
    {
      selecionarEscalaMoeda,
    }
  )
)(SelecaoEscalaMoeda);
